/**
 * Iter114 — Mode demo du portail client.
 *
 * Activation UNIQUEMENT si `client.is_demo === true` (renseigne par le backend
 * pour le compte fixe `demo-portail`). AUCUN flag manuel, AUCUN localStorage.
 *
 * Retour : { isDemoMode }
 */
export function useDemoMode(client) {
  const isDemoMode = !!client?.is_demo;
  return { isDemoMode };
}
